module.exports = __webpack_public_path__ + "static/img/he9.84d51e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he9.png
// module id = C8Cs
// module chunks = 1